import '@fontsource/mulish/200.css';
import '@fontsource/mulish/300.css';
import '@fontsource/mulish/400.css';
import '@fontsource/mulish/400-italic.css';
import '@fontsource/mulish/500.css';
import '@fontsource/mulish/600.css';
import '@fontsource/mulish/700.css';
import '@fontsource/mulish/800.css';
import '@fontsource/mulish/900.css';
import '@mantine/core/styles.layer.css';
import './base.css';
import { Container, MantineProvider, Stack } from '@mantine/core';
import { ReCaptchaProvider } from '@wojtekmaj/react-recaptcha-v3';
import { buildTheme, EMPTY_STRING, zalaLandingThemeBuilderProps } from '@zala-team/ui-web';
import { ZalaAnalyticsProvider } from '#website/components/Analytics/AnalyticsSetup';
import { Footer } from '#website/components/footer/Footer';
import Header from '#website/components/header/Header';
import { LandingProvider } from '#website/layouts/Landing.provider';

const reducedMotionQuery = '(prefers-reduced-motion: no-preference)';

export default function LayoutDefault({ children }: { children: React.ReactNode }) {
	const reducedMotion = typeof window !== 'undefined' && !window.matchMedia(reducedMotionQuery).matches;

	return (
		<ReCaptchaProvider reCaptchaKey={import.meta.env.VITE_RECAPTCHA_SITE_KEY || EMPTY_STRING} language='es-419' useEnterprise={true}>
			<MantineProvider theme={buildTheme({ ...zalaLandingThemeBuilderProps, reducedMotion })} defaultColorScheme={'auto'} classNamesPrefix='z'>
				<LandingProvider>
					<ZalaAnalyticsProvider>
						<Container>
							<Header />
							<Stack>{children}</Stack>
						</Container>
						<Footer />
					</ZalaAnalyticsProvider>
				</LandingProvider>
			</MantineProvider>
		</ReCaptchaProvider>
	);
}
